import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    var elBigLine = document.querySelector(".c-main-visual__big-line");

    function parallax() {
      elBigLine.style.transform = "translateY(" + window.pageYOffset / 1.3 + "px)";
      window.requestAnimationFrame(parallax);
    }

    function scrollAdaptive() {
      $(window).on('scroll', function (event) {
        // ヘッダーの高さを取得
        var header_height = $(".l-header-minimal").height();
        // elScrollableは別項「スクロール位置の取得」を参照
        var scroll_top = $(window).scrollTop();

        if (scroll_top >= header_height) {
          $(".l-header-minimal").addClass("is-scrolling");
        } else {
          $(".l-header-minimal").removeClass("is-scrolling");
        }
      });
    }


    $(function () {
      var $about = $(".c-about__sliders").owlCarousel({
        margin: 0,
        dots: true,
        loop: true,
        nav: true,
        autoplayHoverPause: true,
        autoplay: true,
        autoplaySpeed: 500,
        autoWidth: false,
        autoHeight: false,
        items: 1,
        center: true,
        navText: ['<img src="/wp-content/themes/kyo-yu-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/kyo-yu-html/dist/assets/images/icon-slider-next.svg" />'],
        responsive: {
          // breakpoint from 0 up
          0: {
            items: 1,
          },
          // breakpoint from 750 up
          750: {
            items: 1,
          }
        }
      });
      $about.on("changed.owl.carousel", function (event) {
        $(".c-about__img__number__current").text(('00' + (event.item.index - 1)).slice(-2))
      })
      $(".js-card-slider").owlCarousel({
        margin: 0,
        dots: true,
        loop: true,
        nav: true,
        autoplayHoverPause: true,
        autoplay: true,
        autoplaySpeed: 500,
        autoWidth: false,
        autoHeight: false,
        items: 5,
        center: true,
        navText: ['<img src="/wp-content/themes/kyo-yu-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/kyo-yu-html/dist/assets/images/icon-slider-next.svg" />'],
        responsive: {
          // breakpoint from 0 up
          0: {
            items: 1,
          },
          // breakpoint from 750 up
          750: {
            items: 5,
          }
        }
      });
      $(".c-front-feature__slider").owlCarousel({
        margin: 0,
        dots: true,
        loop: true,
        nav: true,
        autoplayHoverPause: true,
        autoplay: true,
        autoplaySpeed: 500,
        autoWidth: false,
        autoHeight: false,
        items: 3,
        center: true,
        navText: ['<img src="/wp-content/themes/kyo-yu-html/dist/assets/images/icon-slider-prev-circle.svg" />', '<img src="/wp-content/themes/kyo-yu-html/dist/assets/images/icon-slider-next-circle.svg" />'],
        responsive: {
          // breakpoint from 0 up
          0: {
            items: 1,
          },
          // breakpoint from 750 up
          750: {
            items: 3,
          }
        }
      });
      // scrollAdaptive();
      // parallax();
      // anime({
      //   targets: ".c-main-visual__pc-image",
      //   top: ["60%", "50%"],
      //   opacity: ['0', '1'],
      //   duration: 1200,
      //   easing: 'easeInOutQuad(1.8)'
      // });
      // anime({
      //   targets: ".c-main-visual__text",
      //   top: ["60%", "50%"],
      //   opacity: ['0', '1'],
      //   duration: 1200,
      //   delay: 500,
      //   easing: 'easeInOutQuad(1.8)'
      // });
      // anime({
      //   targets: ".c-main-visual__sub-text",
      //   top: ["60%", "50%"],
      //   opacity: ['0', '1'],
      //   duration: 1200,
      //   delay: 700,
      //   easing: 'easeInOutQuad(1.8)'
      // });
      // anime({
      //   targets: ".c-main-visual__book-image",
      //   top: ["55%", "50%"],
      //   opacity: ['0', '1'],
      //   duration: 600,
      //   delay: 1000,
      //   easing: 'easeInOutQuad(1.8)'
      // });
    });
  }
}

window.GApp = new App();
